module.exports = __webpack_public_path__ + "static/img/15.2dd46a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/clientes/15.png
// module id = HSrI
// module chunks = 0